import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";
import { useTenant } from "../lib/tenant";
import { FAQ_CHLOLODESIGNS, FAQ_CHLORINE, FaqSection } from "../data/faq";

export default function FaqPage() {
  const { i18n } = useTranslation();
  const { id: tenantId } = useTenant();
  const isJa = i18n.language.startsWith("ja");

  const sections: FaqSection[] =
    tenantId === "chlorine.art" ? FAQ_CHLORINE : FAQ_CHLOLODESIGNS;

  const [open, setOpen] = useState<Record<string, boolean>>({});

  function toggle(key: string) {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  }

  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-display text-4xl font-bold text-gray-900 mb-2">
        {isJa ? "よくあるご質問" : "Frequently Asked Questions"}
      </h1>
      <p className="text-gray-500 mb-12">
        {isJa
          ? "ご不明な点がある場合は、以下をご確認ください。"
          : "Can't find what you're looking for? Browse the sections below."}
      </p>

      <div className="space-y-10">
        {sections.map((section, si) => (
          <div key={si}>
            <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-4">
              {isJa ? section.title.ja : section.title.en}
            </h2>
            <div className="divide-y divide-gray-100 border border-gray-200 rounded-2xl overflow-hidden">
              {section.items.map((item, ii) => {
                const key = `${si}-${ii}`;
                const isOpen = !!open[key];
                return (
                  <div key={ii}>
                    <button
                      onClick={() => toggle(key)}
                      className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left hover:bg-gray-50 transition-colors"
                    >
                      <span className="font-medium text-gray-900 text-sm">
                        {isJa ? item.q.ja : item.q.en}
                      </span>
                      <ChevronDown
                        size={16}
                        className={`shrink-0 text-gray-400 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
                      />
                    </button>
                    {isOpen && (
                      <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed bg-gray-50">
                        {isJa ? item.a.ja : item.a.en}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
